var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.96396 5.83934L13.1073 10.984C13.2055 11.0822 13.3237 11.1307 13.462 11.1293C13.5997 11.128 13.718 11.0782 13.8166 10.98C13.9148 10.8813 13.964 10.7629 13.964 10.6247C13.964 10.4869 13.9148 10.3687 13.8166 10.27L8.72129 5.17934C8.61374 5.07178 8.49374 4.99311 8.36129 4.94334C8.22885 4.89356 8.0964 4.86889 7.96396 4.86934C7.83151 4.86978 7.69907 4.89445 7.56663 4.94334C7.43418 4.99222 7.31418 5.07089 7.20663 5.17934L2.11063 10.274C2.0124 10.3727 1.96396 10.4904 1.96529 10.6273C1.96663 10.7638 2.0164 10.8811 2.11463 10.9793C2.21285 11.0776 2.33107 11.1267 2.46929 11.1267C2.60751 11.1267 2.72551 11.0776 2.82329 10.9793L7.96396 5.83934Z",
    fill: "#C7CBD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c616e6321f62df20411748c45d78522a.svg";
export { ForwardRef as ReactComponent };